const OrderFilters = {
    filters:{
        // 列表订单状态过滤器
        status({val,lang}){
            switch (val) {
                case 0:
                    return lang.filter1
                    break;
                case 1:
                    return lang.filter2
                    break;
                case 2:
                    return lang.filter3
                    break;
                case 3:
                    return lang.filter4
                    break;
                case 4:
                    return lang.filter27
                    break;
            }
        },
        orstatus({val,lang}){
            switch (val) {
                case '0':
                    return lang.filter5
                    break;
                case '1':
                    return lang.filter6
                    break;
                case '2':
                    return lang.filter7
                    break;
                case '3':
                    return lang.filter8
                    break;
                case '4':
                    return lang.filter9
                    break;
                case '5':
                    return lang.filter10
                    break;
                case '6':
                    return lang.filter11
                    break;
                case '7':
                    return lang.filter12
                    break;
                case '8':
                    return lang.filter13
                    break;
            }
        },
        pay_status({val,lang}){
            switch (val) {
                case '0':
                    return lang.filter23
                    break;
                case '10':
                    return lang.filter24
                    break;
                case '20':
                    return lang.filter25
                    break;
                case '30':
                    return lang.filter26
                    break;
            }
        }
    }
}

export { OrderFilters }